import styled from 'styled-components';
import { SYS_BREAKPOINT_2_XL, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, SYS_PAGE_MARGIN_2_XL, SYS_PAGE_MARGIN_LG, SYS_PAGE_MARGIN_MD, SYS_PAGE_MARGIN_SM, SYS_PAGE_MARGIN_XL, } from '@oneaudi/unified-web-common';
export const ConsumptionAndEmissionTextStyle = styled.div `
  width: 100%;
  height: max-content;
  min-height: 3rem;
  background: white;
  line-height: 18px;

  &.vertical-padding {
    padding: 12px 0;
  }

  &.paddings {
    padding: 12px ${SYS_PAGE_MARGIN_SM};

    @media screen and (min-width: ${SYS_BREAKPOINT_SM}) {
      padding-left: ${SYS_PAGE_MARGIN_SM};
      padding-right: ${SYS_PAGE_MARGIN_SM};
    }

    @media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
      padding-left: ${SYS_PAGE_MARGIN_MD};
      padding-right: ${SYS_PAGE_MARGIN_MD};
    }

    @media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
      padding-left: ${SYS_PAGE_MARGIN_LG};
      padding-right: ${SYS_PAGE_MARGIN_LG};
    }

    @media screen and (min-width: ${SYS_BREAKPOINT_XL}) {
      padding-left: ${SYS_PAGE_MARGIN_XL};
      padding-right: ${SYS_PAGE_MARGIN_XL};
    }

    @media screen and (min-width: ${SYS_BREAKPOINT_2_XL}) {
      padding-left: ${SYS_PAGE_MARGIN_2_XL};
      padding-right: ${SYS_PAGE_MARGIN_2_XL};
    }
  }

  .text-wrapper {
    display: inline;

    .entry-wrapper {
      display: inline;
      sup {
        font-size: 0.583em;
      }
    }
  }
`;
